import HttpService from 'services/HttpServiceBasic';
import { AA_XHR_BASE_PATH } from 'aa/vue/constants/aaRoutes';

export default class BranchIOSetup {
    constructor(config) {
        // branch io features
        this.validateKey(config.key);
        this.branchKey = config.key ?? '';
        this.flowType = config?.flowType ?? '';
        this.isAbTestFlow = config?.isAbTestFlow ?? false;

        // local vars
        this.tryCounter = 0;
        this.tryCounterMax = 50;

        // maybe we should make options dynamic, will do later if that will be required
        this.options = {
            no_journeys: false,
        };

        // flags for branch
        this.isBranchInitialized = false;
        this.willNotShowJourney = false;
        this.didShowJourney = false;

        // auto login features
        this.autoLoginEnabled = config?.autoLoginEnabled ?? false;
        this.token = null;

        // need to make sure about init method, should we call OR mops will do
        this.init();
        this.addListeners();
        this.dispatcher = document.createElement('div');
    }

    validateKey(key) {
        if (!key) {
            console.warn('Required Branch Key is missing');
        }
    }

    init() {
        if (window.branch) {
            this.initWithAutoLogin().then(() => {
                this.isBranchInitialized = true;
            });
        } else {
            if (this.tryCounter <= this.tryCounterMax) {
                this.tryAgain();
            }
        }
    }

    async initWithAutoLogin() {
        await this.getAutoLoginToken()
            .then((token) => {
                this.token = token;
                this.afterInit();
            })
            .catch(() => {
                this.afterInit();
            });
    }

    async getAutoLoginToken() {
        return new Promise((resolve, reject) => {
            if (!this.autoLoginEnabled) {
                reject(false);
                return;
            }

            const http = new HttpService();
            let path = `/delta/xhr/generateAutoLoginToken/`;
            if (this.isAbTestFlow) {
                path = `${AA_XHR_BASE_PATH}processIosSignup/`;
            }
            http.doGet(path)
                .then((res) => {
                    if (res?.success && res?.result) {
                        resolve(res.result);
                    } else {
                        reject(false);
                    }
                })
                .catch((err) => {
                    reject(false);
                });
        });
    }

    afterInit() {
        window.branch.init(this.branchKey, this.options, (err, data) => {
            if (data) {
                if (this.token) {
                    const linkData = {
                        data: {
                            binding_key: this.token, // using name "binding_key" to not show its purpose
                            flow_type: this.flowType, //mobile teams wants reseller name
                        },
                    };
                    window.branch.setBranchViewData(linkData);
                }
            }
        });
    }

    tryAgain() {
        setTimeout(() => {
            this.tryCounter++;
            this.init();
        }, 50);
    }

    addListeners() {
        try {
            if (window.branch) {
                window.branch.addListener(this.listener.bind(this));
            }
        } catch (e) {}
    }

    listener(event, detail) {
        // relay event to component that is listening
        const e = new CustomEvent(event);
        this.dispatcher.dispatchEvent(e);
    }
}
